import { categorySchema, type Category, type CategoryInput } from '@app/shared';
import { z } from 'zod';
import { apiFetch } from '@/lib/api';

export function fetchCategories(includeInactive = false): Promise<Category[]> {
  return apiFetch(`/api/categories?includeInactive=${includeInactive}`, { schema: z.array(categorySchema) });
}

export function createCategory(input: CategoryInput): Promise<Category> {
  return apiFetch('/api/categories', { method: 'POST', body: input, schema: categorySchema });
}
